module.exports = __webpack_public_path__ + "static/media/457.2ab1468b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/457.svg
// module id = 543
// module chunks = 0